export default {
  container: {
    backgroundColor: 'lightblue',
    marginTop: -48,
  },
  nohistory: {
    textAlign: 'center',
  },
};


// WEBPACK FOOTER //
// ./src/components/Tasks/TaskDialog/TaskTimeline/styles.js